import { render } from "./SideTab.vue?vue&type=template&id=9e5aee00"
import script from "./SideTab.vue?vue&type=script&lang=js"
export * from "./SideTab.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ts/Desktop/works/vue3_portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__